class CalculatorPeriodSelector {
	constructor(el) {
		this.el = el;

		this.start();
	}

	get days() {
		const selectedDays = this.periodRadios.find(o => o.checked);
		const source = selectedDays || this.daysInput;

		return source.value;
	}

	start() {
		this.periodRadios = Array.from(this.el.querySelectorAll('[name="periodSelect"]'));
		this.daysInput = this.el.querySelector('[name="amountOfDays"]');
		this.daysInput.addEventListener('input', () => this.onInput());

		this.el.addEventListener('change', e => this.onChange(e));
	}

	onChange(e) {
		const { target: { name } } = e;

		if (name === 'periodSelect') {
			this.onPeriodSelect();
		}
	}

	onInput() {
		this.deselectPeriods();
		this.daysInput.required = true;
	}

	onPeriodSelect() {
		this.daysInput.value = '';
		this.daysInput.required = false;
	}

	deselectPeriods() {
		this.periodRadios.forEach(i => (i.checked = false));
	}
}

export default CalculatorPeriodSelector;
